import { MixedSchema } from '@framework/validation';
import React from 'react';
import { IFieldSchemaValidation } from '../field/useFieldSchemaValidation';
import { LeafError } from '../form/errors/LeafError';

export interface IFormItemContext {
  ariaLabelId?: string;
  errors?: LeafError[];
  warnings?: string[];
  validation?: IFieldSchemaValidation;
  enabled?: boolean;
  layoutEnabled?: boolean;
  schema?: MixedSchema[];
  readonly?: boolean;
  name?: Array<string | undefined>;
  setLabelAddition?: (labelAddition: React.ReactNode | undefined) => void;
}

/**
 * Contesto accessibile ai singoli Input contenente informazioni sullo
 * stato di validazione del campo e sullo schema di validazione a cui è
 * collegato.
 * È possibile utilizzare questo contesto per aggiungere informazioni
 * necessarie all'accessibilità o anche per altri usi.
 */
export const FormItemContext = React.createContext<IFormItemContext>({});

export function useFormItemContext() {
  return React.useContext(FormItemContext);
}
